import React from 'react';
import {useLocation} from 'react-router-dom';
import {useContextSelector} from 'use-context-selector';
import {Nav} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {useTranslation} from 'react-i18next';
import createUUID from '../util/createUUID';
import {LocalContext} from '../context/LocalContext';

const LinksPrimary = (props) => {
    const {t} = useTranslation();
    const location = useLocation();
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);

    const links = [
        {
            children: t(`Links.home`),
            to: '/'
        },
        {
            children: t(`Links.find-providers`),
            to: '/providers-search',
        },
        {
            children: t(`Links.provider-application`),
            to: '/provider-application'
        },
        {
            children: t(`Links.account-dashboard`),
            to: '/dashboard',
            active: location.pathname.split('/')[1] === 'dashboard',
            mustAuth: true
        },
    ]

    const linksFragment = [];


    for (const link of links) {
        if (link.mustAuth && !userAuthenticated) {
            continue
        }
        linksFragment.push((
            <LinkContainer
                key={createUUID()}
                to={link.to}
                exact={true}
            >
                <Nav.Link
                    active={link.active ? link.active : false}
                >
                    <span>{link.children}</span>
                </Nav.Link>
            </LinkContainer>
        ))
    }

    return (<>
        <Nav className={[props.attachClasses]}>
            {linksFragment}
        </Nav>
    </>)
}

export default LinksPrimary;
